import { useT } from '@/lib/i18n';
import { useApp } from '@/store';

/**
 * Full-screen cold-start loader shown on the very first login for a large
 * tenant, while PouchDB replicates the initial data set for offline use. Once
 * `firstSyncComplete` flips true (see AuthGate), this unmounts and the normal
 * app renders.
 */
export function FirstSyncScreen() {
  const t = useT();
  const loaded = useApp(s => s.syncLoaded);
  const target = useApp(s => s.syncTarget);
  const pct =
    target && target > 0
      ? Math.min(100, Math.round((loaded / target) * 100))
      : 0;

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <img src="/logo-wordmark.svg" alt="Look2it" className="h-8" />

      <div className="w-full max-w-sm space-y-3">
        <p className="text-sm font-medium text-foreground">
          {t('sync.loading')}
        </p>
        <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
          <div
            className="h-full rounded-full bg-primary transition-all duration-300"
            style={{ width: `${pct}%` }}
            role="progressbar"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
        <p className="text-xs tabular-nums text-muted-foreground">
          {target ? `${loaded} / ${target}` : `${loaded}`}
        </p>
      </div>

      <p className="max-w-xs text-xs text-muted-foreground">{t('sync.hint')}</p>
    </div>
  );
}
